import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, Entity, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { Servicios } from "../../Servicios/Servicios";
import { ClientesServicios } from "./ClientesServicios";

export const ACTSeleccionarServicios: EntityClientAction = {
    name: 'ACTSeleccionarServicios',
    label: 'Selección múltiple',
    title: <Text fw={700}>Seleccionar servicios</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        // cast entity
        const parent = entity as ClientesServicios;
        const servicios = new Servicios(entity.API.client);
        servicios.parentKeys = parent.parentKeys;


        if (modal) {
            await modal.open({
                modalProps: {
                    title: <Text fw="700">Seleccionar servicios</Text>,
                },
                focusOnClosed: element,
                content: <LookupFormAction
                    lookupEntity={servicios}
                    viewName={servicios.def.views.serv_brwStandard.name}
                    title="Agregar servicios seleccionados"
                    onActionFinished={async () => { if (onClose) await onClose(); }}
                    onOK={
                        async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                            const clientes_servicios = Entity.clone(parent) as ClientesServicios;

                            clientes_servicios.def.columns.c_cliente_id.value = parent.parentKeys[clientes_servicios.def.columns.c_cliente_id.name] as string;

                            const result = await clientes_servicios.API.addData(abortSignal, keys, true);

                            return result;
                        }
                    }
                />

            });
        }
        else {
            console.log('modal context not found');
        }

        return Promise.resolve(false);

    }

}

